import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import useClient from "../../hooks/useClient";
import useProject from "../../hooks/useProject";
import useData from "../../hooks/useData";

import { Box, Button, Stack } from "@mui/material";

import Select from "../elements/Select";

const LocationAssignment = ({ locations, onAssigned }) => {
  const { getClients, clients } = useClient();
  const { getProjects, projects } = useProject();
  const { addToWorkQueue } = useData();

  const [clientId, setClientId] = useState("");
  const [projectId, setProjectId] = useState("");

  const userId = useSelector((state) => state.authentication.userId);
  const email = useSelector((state) => state.authentication.email);

  useEffect(() => {
    getClients({ isActive: true });
  }, []);

  useEffect(() => {
    getProjects({ clientId });
  }, [clientId]);

  const handleAssignLocations = async () => {
    const details = {
      userId: userId,
      email: email,
      projectId,
      data: locations,
    };

    const results = await addToWorkQueue("importProjectLocations", details);

    onAssigned();
  };

  return (
    <Stack
      sx={{ padding: "10px" }}
      spacing={1}
    >
      <Select
        label="Clients"
        items={clients}
        value={clientId}
        onChange={(newValue) => setClientId(newValue)}
      />
      <Select
        label="Projects"
        items={projects}
        value={projectId}
        onChange={(newValue) => setProjectId(newValue)}
      />
      <Button
        variant="contained"
        onClick={handleAssignLocations}
        disabled={!projectId}
      >
        Assign locations to project
      </Button>
    </Stack>
  );
};

export default LocationAssignment;
